// The pages behind the category claims on the comparison pages, and the day they were read (S34.03).
// Each is platform documentation or a regulator's guidance, never a vendor of the category.
export const CHECKED_ON = "2026-10-31";

export const SOURCES = {
  contentScripts: "https://developer.chrome.com/docs/extensions/develop/concepts/content-scripts",
  extensionPermissions: "https://support.google.com/chrome_webstore/answer/186213",
  boughtInLists:
    "https://ico.org.uk/for-organisations/direct-marketing-and-privacy-and-electronic-communications/guidance-on-direct-marketing-using-electronic-mail/how-do-we-comply-with-the-pecr-electronic-mail-marketing-rules/",
  crawler: "https://developer.mozilla.org/en-US/docs/Glossary/Crawler",
  markupChanges: "https://playwright.dev/docs/best-practices",
} as const;
